/* import __COLOCATED_TEMPLATE__ from './conversation-card-compact.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();